// Copyright (c) 2016 Deere & Company

import './search-box.scss';
import React, {PropTypes} from 'react';
import {injectIntl, intlShape} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import TranslatedInput from '../../../shared/components/translated-input';

function handleTextChange(event) {

    this.onQueryChange(event.target.value);

}

function onSubmit(event) {

    this.onSearch(this.queryString.trim());

    event.preventDefault();

}

function handleFocus(event) {

    if (event.target.value) {

        event.target.select();

    }

}

function handleOptionChange(event) {

    this.onOptionChange(event.target.value);

}

const SearchBox = props =>

    props.searchBy.length > 0 &&
        <form
            className='search-box'
            onSubmit={props::onSubmit}
            spellCheck={false}
        >
            <div className='sort-by-group'>
                <select
                    onChange={props::handleOptionChange}
                    value={props.defaultOption}
                >
                    {props.searchBy.map(option =>
                        <option
                            key={option.key}
                            value={option.key}
                        >
                            {props.intl.formatMessage({id: option.value})}
                        </option>)}
                </select>
            </div>
            <TranslatedInput
                onChange={props::handleTextChange}
                onFocus={props::handleFocus}
                placeholder={props.placeholderText}
                type='text'
                value={props.queryString}
            />
            <button
                className='search-button'
            >
                <span className='icon-search'/>
            </button>
        </form>;

SearchBox.displayName = 'SearchBox';
SearchBox.propTypes = {
    defaultOption: PropTypes.string,
    intl: intlShape.isRequired,
    onOptionChange: PropTypes.func.isRequired,
    onQueryChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    placeholderText: PropTypes.string.isRequired,
    queryString: PropTypes.string,
    searchBy: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default injectIntl(SearchBox);



// WEBPACK FOOTER //
// ./src/shared/components/search-box/index.js